import { DEFAULT_LOCALE, localizedPath } from '@/i18n/config';
import { getLocalized } from './localize';

/** Altezza approssimativa dell'header fisso — offset per non far finire la sezione-ancora sotto l'header scrollando. */
export const ANCHOR_SCROLL_OFFSET = -90;

/**
 * Nav unificata del sito — stessa lista su ogni pagina, due tipi di voce:
 *  - ancore alle sezioni della Home marcate showInNav (modalità one-page:
 *    scroll fluido, vedi lo scroll-to-hash in App.jsx)
 *  - link alle altre pagine marcate showInNav (navigazione normale)
 * Un'ancora cliccata da una pagina diversa dalla Home naviga a "/" col
 * relativo hash — lo scroll avviene dopo il mount, non serve gestirlo qui.
 */
export function getNavItems(pages, locale = DEFAULT_LOCALE) {
  const home = pages.find((p) => p.slug === '/');
  const homeHref = localizedPath('/', locale);

  // Un'ancora/pagina "in nav" ma senza testo compilato non va renderizzata:
  // un link vuoto occupa comunque il suo padding, sembra uno spazio rotto
  // nel menu invece che una voce mancante.
  const sectionAnchors = (home?.sections || [])
    .filter((s) => s.showInNav)
    .map((s) => ({
      id: s.id,
      href: `${homeHref}#${s.id}`,
      label: getLocalized(s.navLabel, locale) || getLocalized(s.navLabel, DEFAULT_LOCALE),
      isAnchor: true,
      slug: null,
    }))
    .filter((item) => item.label.trim());

  const pageLinks = pages
    .filter((p) => p.showInNav)
    .map((p) => ({
      id: p.id,
      href: localizedPath(p.slug, locale),
      label: getLocalized(p.navLabel, locale) || getLocalized(p.navLabel, DEFAULT_LOCALE),
      isAnchor: false,
      slug: p.slug,
    }))
    .filter((item) => item.label.trim());

  return [...sectionAnchors, ...pageLinks];
}
